<div class="space-y-6">
  <app-page-header
    title="Resources"
    subtitle="Entités protégées sur lesquelles les permissions s'appliquent."
  >
    <a
      slot="actions"
      routerLink="/permissions/resources/new"
      class="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-medium text-white shadow-theme-xs transition hover:bg-brand-600"
    >
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M10 4.167v11.666M4.167 10h11.666" stroke="currentColor" stroke-width="1.667" stroke-linecap="round" />
      </svg>
      Nouvelle resource
    </a>
  </app-page-header>

  <app-permissions-tabs />

  <section class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    @if (error() || loading() || resources().length === 0) {
      <app-data-state
        [loading]="loading()"
        [error]="error()"
        [empty]="!loading() && !error() && resources().length === 0"
        emptyMessage="Aucune resource."
        (retry)="load()"
      />
    } @else {
      <div class="overflow-x-auto rounded-2xl">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-800">
          <thead class="bg-gray-50 dark:bg-white/[0.02]">
            <tr>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Nom</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Type</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">URIs</th>
              <th class="px-5 py-3 text-left text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Scopes</th>
              <th class="px-5 py-3 text-right text-theme-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white dark:divide-gray-800 dark:bg-transparent">
            @for (r of resources(); track r.id || r.name) {
              <tr class="transition hover:bg-gray-50 dark:hover:bg-white/[0.02]">
                <td class="px-5 py-4">
                  <p class="font-mono text-sm font-medium text-gray-800 dark:text-white/90">{{ r.name }}</p>
                  @if (r.displayName && r.displayName !== r.name) {
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ r.displayName }}</p>
                  }
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-xs text-gray-500 dark:text-gray-400">{{ r.type || '—' }}</td>
                <td class="px-5 py-4">
                  @if (r.uris?.length) {
                    <ul class="space-y-0.5">
                      @for (u of r.uris; track u) {
                        <li class="break-all font-mono text-[11px] text-gray-700 dark:text-gray-300">{{ u }}</li>
                      }
                    </ul>
                  } @else {
                    <span class="text-xs text-gray-400">—</span>
                  }
                </td>
                <td class="px-5 py-4">
                  @if (r._scopeNames.length) {
                    <div class="flex flex-wrap gap-1">
                      @for (s of r._scopeNames; track s) {
                        <span class="inline-flex items-center rounded-full bg-brand-50 px-2 py-0.5 text-[10px] font-medium text-brand-700 dark:bg-brand-500/15 dark:text-brand-400">{{ s }}</span>
                      }
                    </div>
                  } @else {
                    <span class="text-xs text-gray-400">—</span>
                  }
                </td>
                <td class="whitespace-nowrap px-5 py-4 text-right">
                  <a [routerLink]="['/permissions/resources', r.id]" class="text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">Voir</a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="border-t border-gray-200 px-5 py-3 text-xs text-gray-500 dark:border-gray-800 dark:text-gray-400">
        {{ resources().length }} resource(s)
      </div>
    }
  </section>
</div>
